import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SectionHeaderWrapper = styled.div`
    margin-top: 40px;
    margin-bottom: 24px;
`;

export const HeaderWithChannelWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 24px;
`;

export const FullWidthWrapper = styled.div`
    width: 100%;
`;

export const AICtaSectionWrapper = styled(FullWidthWrapper)`
    container-name: ai-report-cta-section-wrapper;
    container-type: inline-size;
`;

export const EngagementOverviewTableWrapper = styled(FullWidthWrapper)`
    margin: 24px 0;
`;

export const SearchTrafficWrapper = styled(FullWidthWrapper)`
    margin-bottom: 24px;
`;

export const TwoInARowWrapper = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;

    > * {
        width: calc(50% - 12px);
    }
`;

export const RowWrapper = styled.div`
    padding: 0 12px;
`;

const OpenAIWrapper = styled(FullWidthWrapper)`
    margin-top: 54px;
`;
